import { Component, Input, OnInit } from "@angular/core";
import { AdvancedElementInterface } from "../../interfaces/advanced-element.interface";
import {
  AdvancedContactInformationControls,
  Keys,
} from "./advanced-contact-information.controls";
import { GENDERS } from "./constants";

@Component({
  selector: "fpt-advanced-contact-information",
  templateUrl: "./advanced-contact-information.component.html",
  styleUrls: ["./advanced-contact-information.component.scss"],
})
export class AdvancedContactInformationComponent
  extends AdvancedContactInformationControls
  implements OnInit
{
  @Input()
  component!: AdvancedElementInterface;
  readonly genders = GENDERS;
  get ControlKeys() {
    return Keys;
  }

  ngOnInit(): void {
    this.register(this.component);
  }

  //only number will be add
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  get f() {
    return this.documentForm.controls;
  }
}
